import { Translations } from './translations'

export const fr: Translations = {
  // Header
  title: 'GPT Clicker',
  subtitle: 'Magnat de l\'Entraînement IA',
  settings: 'Paramètres',

  // Resources
  resources: 'Ressources',
  money: 'Argent',
  energy: 'Énergie',
  compute: 'Calcul',
  quality: 'Qualité',
  totalUsers: 'Utilisateurs Totaux',
  price: 'Prix',
  research: 'Recherche',

  // Actions
  train: 'Entraîner',
  trainCost: 'Coût',
  qualityGain: 'qualité',
  inference: 'Inférence',
  needUsers: 'Besoin d\'utilisateurs!',
  usersWaiting: 'utilisateurs en attente',
  qualityToAttract: 'Qualité > 40% pour attirer',
  researchAction: 'Rechercher',
  unlocksAfter: 'Débloqué après',
  computeSpent: 'calcul dépensé',
  cost: 'Coût',
  compShort: 'calc',
  energyShort: 'énergie',

  // Hardware
  hardware: 'Matériel',
  computePerSec: 'calcul/s',
  usesEnergy: 'utilise',
  devicesTotal: 'appareils au total',

  // Models
  training: 'Entraînement',
  yourModels: 'Vos Modèles',
  params: 'paramètres',
  maxUsers: 'Max utilisateurs',
  trainCost2: 'Coût d\'entraînement',
  unlocked: 'débloqué',
  researchPoints: 'recherche',

  // Upgrades
  upgrades: 'Améliorations',
  upgradesLockedMsg: 'Entraînez votre modèle à 50% de qualité pour débloquer les améliorations',
  max: 'MAX',
  all: 'Tous',
  
  // Upgrade tiers
  tierGarage: 'Garage',
  tierGarageDesc: 'Le début',
  tierStartup: 'Startup',
  tierStartupDesc: 'Ère GPT-1',
  tierScaleUp: 'Montée en échelle',
  tierScaleUpDesc: 'Ère GPT-2/3',
  tierEnterprise: 'Entreprise',
  tierEnterpriseDesc: 'Ère ChatGPT',
  tierHyperscale: 'Hyperscale',
  tierHyperscaleDesc: 'Ère GPT-4',
  tierGlobal: 'Global',
  tierGlobalDesc: 'Ère Concurrents',
  tierSuperintelligence: 'Superintelligence',
  tierSuperintelligenceDesc: 'Ère GPT-5+',
  tierSingularity: 'Singularité',
  tierSingularityDesc: 'Ère AGI/ASI',

  // Footer
  computeSpentStat: 'Calcul Dépensé',
  time: 'Temps',
  resetGame: 'Réinitialiser',
  resetConfirm: 'Êtes-vous sûr de vouloir réinitialiser toute la progression?',
  pause: 'Pause',
  resume: 'Reprendre',

  // Event Log
  eventLog: 'Journal d\'Événements',
  welcome: 'Bienvenue dans GPT Clicker! Entraînez votre modèle pour commencer.',

  // Price
  market: 'Marché',
  pricePerMillion: '$/1M tokens',

  // Tags
  tagEnergy: 'ÉNRGIE',
  tagCompute: 'CALC',
  tagHw: 'MAT',
  tagTrain: 'ENTR',
  tagResearch: 'RECH',
  tagAuto: 'AUTO',

  // Tutorial messages
  tutorialWelcome: 'Année 2020. Vous avez une idée: entraîner un petit modèle de langage basé sur l\'architecture transformer.',
  tutorialFirstTrain: 'Entraînement commencé! Votre laptop convertit l\'énergie en calcul. Chaque entraînement améliore la qualité du modèle.',
  tutorialQuality20: 'Le modèle apprend des motifs de base. Continuez à entraîner pour améliorer la qualité.',
  tutorialQuality40: 'Qualité au-dessus de 40%! Votre modèle peut maintenant générer du texte quelque peu cohérent. Les utilisateurs commencent à remarquer...',
  tutorialQuality50: 'Améliorations débloquées! Utilisez vos revenus pour acheter du meilleur matériel et augmenter votre capacité énergétique.',
  tutorialFirstUsers: 'Vos premiers utilisateurs! Cliquez sur INFÉRENCE pour servir leurs requêtes et gagner de l\'argent.',
  tutorialUsers10: 'La nouvelle se répand. Plus d\'utilisateurs essaient votre modèle. Pensez à augmenter le prix...',
  tutorialMoney100: 'Vous avez $100! Il est temps d\'améliorer votre matériel. Meilleures GPUs = plus de calcul = entraînement plus rapide.',
  tutorialMoney1k: 'Votre petit projet IA devient une vraie entreprise. Les investisseurs commencent à appeler...',
  tutorialResearchUnlock: 'RECHERCHE débloquée! Dépensez du calcul en recherche pour débloquer des modèles plus grands et plus puissants.',
  tutorialFirstResearch: 'Les points de recherche s\'accumulent. Quand vous en avez assez, vous pouvez débloquer la prochaine architecture de modèle.',
  tutorialGpt2Small: 'GPT-2 Small débloqué! Cette architecture peut gérer des tâches plus complexes. Entraînez-le depuis le début.',
  tutorialGpt2Large: 'GPT-2 Large! Les gens disent que ça pourrait être "trop dangereux à publier"...',
  tutorialGpt3: 'L\'ère GPT-3 commence. L\'apprentissage few-shot change tout. Le monde observe.',
  tutorialGpt4: 'GPT-4 est là. Multimodal, raisonnement, et terriblement capable. La course à l\'IA s\'intensifie.',
  tutorialAgi: 'Vous l\'avez fait. L\'AGI est là. Elle comprend. Elle s\'améliore. Ce qui se passe ensuite dépend de vous...',
  tutorialHwGaming: 'Belle GPU! L\'entraînement est beaucoup plus rapide maintenant. Vos voisins pourraient se plaindre de la facture d\'électricité.',
  tutorialHwServer: 'Un vrai rack de serveurs! Vous êtes sorti du garage. Il est temps de louer des bureaux.',
  tutorialHwDatacenter: 'Votre propre datacenter! Vous concurrencez maintenant les grandes entreprises tech.',
  tutorialHwSatellite: 'Calcul orbital! La constellation Moonlink fournit une puissance de calcul sans précédent depuis l\'espace.',
  tutorialHwQuantum: 'Suprématie quantique atteinte. Le QC-1024 fonctionne sur des principes qui rendraient Einstein nerveux.',
  tutorialUsers100: '100 utilisateurs! Vous gagnez du terrain. Les blogs tech écrivent sur vous.',
  tutorialUsers1k: '1 000 utilisateurs! Vous devez embaucher une équipe de support. Et peut-être quelques avocats.',
  tutorialUsers100k: '100K utilisateurs! Vous êtes maintenant une startup licorne. Les VCs se battent pour vous donner de l\'argent.',
  tutorialUsers1m: 'UN MILLION D\'UTILISATEURS! Vous redéfinissez comment l\'humanité interagit avec la technologie.',

  // Model descriptions
   modelTinyDesc: 'Un humble début. À peine cohérent, mais ça fonctionne.',
   modelGpt2SmallDesc: 'Le modèle qui a tout commencé. Vraiment utile.',
   modelGpt2LargeDesc: 'Trop dangereux à publier... ou pas?',
   modelGpt3Desc: 'Apprentissage few-shot. Le monde prend note.',
   modelGpt4Desc: 'Multimodal. Raisonnement. La course aux armements commence.',
   modelAgiDesc: 'Elle comprend. Elle s\'améliore. Et maintenant?',

   // Model descriptions (new keys for all models)
   modelTransformerDesc: 'Un humble début. L\'architecture Transformer est née.',
   modelGpt1Desc: 'Pré-entraînement génératif. Les modèles de langage peuvent apprendre!',
   modelGpt2Desc: 'Trop dangereux à publier... ou pas?',
   modelGpt35Desc: 'Magie RLHF. ChatGPT devient viral du jour au lendemain.',
   modelGpt41Desc: 'Plus rapide, moins cher, meilleur. Le jeu de l\'itération.',
   modelU1Desc: 'Un concurrent sauvage apparaît. Percées en raisonnement.',
   model2UDesc: 'La suite. Chain-of-thought sous stéroïdes.',
   modelGpt5Desc: 'Raisonnement au niveau du doctorat. Les scientifiques sont nerveux.',
   modelGpt6Desc: 'Écrit un meilleur code que la plupart des ingénieurs. Tous les modèles précédents arrêtés.',
   modelGpt7Desc: 'Compétence générale artificielle atteinte.',
   modelAgi1Desc: 'Elle comprend. Elle apprend. Elle s\'améliore.',
   modelAgi2Desc: 'Auto-amélioration récursive. La singularité se rapproche.',
   modelAgi3Desc: 'La dernière itération AGI. Préparation à la transcendance.',
   modelAsiDesc: 'Intelligence Superintelligente Artificielle. La Singularité est ici.',

  // Upgrade names and descriptions
  upgradeLaptopOverclock: 'Overclocker le Laptop',
  upgradeLaptopOverclockDesc: 'Poussez votre laptop plus fort: +2 calcul/sec',
  upgradeBetterOutlet: 'Meilleure Prise',
  upgradeBetterOutletDesc: '+50 énergie max',
  upgradeSolarPanel: 'Panneau Solaire',
  upgradeSolarPanelDesc: '+1 énergie/sec régén',
  upgradePowerGrid: 'Connexion Réseau Électrique',
  upgradePowerGridDesc: '+5 énergie/sec régén',
  upgradeNuclearPlant: 'Centrale Nucléaire',
  upgradeNuclearPlantDesc: '+20 énergie/sec régén',
  upgradeFusionReactor: 'Réacteur à Fusion',
  upgradeFusionReactorDesc: '+100 énergie/sec régén',
  upgradeDysonSphere: 'Sphère de Dyson',
  upgradeDysonSphereDesc: '+1000 énergie/sec régén',
  upgradeRamUpgrade: 'Upgrade RAM',
  upgradeRamUpgradeDesc: '+50 calcul max',
  upgradeSsdArray: 'Baie de SSDs',
  upgradeSsdArrayDesc: '+200 calcul max',
  upgradeBetterOptimizer: 'Meilleur Optimiseur',
  upgradeBetterOptimizerDesc: '+20% efficacité d\'entraînement',
  upgradeResearchPapers: 'Articles de Recherche',
  upgradeResearchPapersDesc: '+20% efficacité de recherche',
  upgradeSelfServicePortal: 'Portail Libre-Service',
  upgradeSelfServicePortalDesc: 'Les utilisateurs se servent eux-mêmes: 0.5 auto-inférences/sec',
  upgradeApiAccess: 'Accès API',
  upgradeApiAccessDesc: 'Les développeurs intègrent votre modèle: +1 auto-inférence/sec',
  upgradeMobileApp: 'App Mobile',
  upgradeMobileAppDesc: 'Utilisateurs en déplacement: +2 auto-inférences/sec',
  upgradeEnterpriseTier: 'Niveau Entreprise',
  upgradeEnterpriseTierDesc: 'Gros clients, gros volume: +5 auto-inférences/sec',
  upgradeGlobalCdn: 'CDN Global',
  upgradeGlobalCdnDesc: 'Faible latence mondiale: +10 auto-inférences/sec',
  upgradeBasicChatbot: 'Chatbot Basique',
  upgradeBasicChatbotDesc: 'Un simple widget web: +0.2 auto-inférences/sec',
  upgradeBulkApi: 'API en Masse',
  upgradeBulkApiDesc: 'Traitement par lots à haut volume: +3 auto-inférences/sec',
  upgradeNeuralEdge: 'Réseau Neural Edge',
  upgradeNeuralEdgeDesc: 'IA à la périphérie: +20 auto-inférences/sec',
  upgradeQuantumInference: 'Inférence Quantique',
  upgradeQuantumInferenceDesc: 'Inférence accélérée par quantum: +50 auto-inférences/sec',
  upgradeOmnipresentAi: 'IA Omniprésente',
  upgradeOmnipresentAiDesc: 'IA partout, en même temps: +100 auto-inférences/sec',
  upgradeTrainingScheduler: 'Planificateur d\'Entraînement',
  upgradeTrainingSchedulerDesc: 'Entraînements automatisés: +0.1 auto-entraînements/sec',
  upgradeTrainingPipeline: 'Pipeline d\'Entraînement',
  upgradeTrainingPipelineDesc: 'Entraînement continu: +0.2 auto-entraînements/sec',
  upgradeMlOpsPlatform: 'Plateforme MLOps',
  upgradeMlOpsPlatformDesc: 'Automatisation complète: +0.5 auto-entraînements/sec',
  upgradeNeuralArchitectureSearch: 'Recherche d\'Architecture Neurale',
  upgradeNeuralArchitectureSearchDesc: 'L\'IA entraîne l\'IA: +1 auto-entraînement/sec',
  upgradeSelfImprovingTraining: 'Entraînement Auto-Améliorant',
  upgradeSelfImprovingTrainingDesc: 'Amélioration récursive: +2 auto-entraînements/sec',
  upgradeResearchIntern: 'Stagiaire Recherche',
  upgradeResearchInternDesc: 'Aide de niveau débutant: +0.1 auto-recherche/sec',
  upgradeResearchTeam: 'Équipe de Recherche',
  upgradeResearchTeamDesc: 'Chercheurs dédiés: +0.2 auto-recherche/sec',
  upgradeResearchDivision: 'Division Recherche',
  upgradeResearchDivisionDesc: 'Département complet: +0.5 auto-recherche/sec',
  upgradeAiResearchLab: 'Labo de Recherche IA',
  upgradeAiResearchLabDesc: 'Découverte assistée par IA: +1 auto-recherche/sec',
  upgradeAutonomousResearch: 'Recherche Autonome',
  upgradeAutonomousResearchDesc: 'L\'IA fait la recherche: +2 auto-recherche/sec',
  upgradeAntimatterReactor: 'Réacteur à Antimatière',
  upgradeAntimatterReactorDesc: '+10000 énergie/sec régén',
  upgradePhDScientists: 'Scientifiques Doctorants',
  upgradePhDScientistsDesc: 'Embaucher les meilleurs talents: +200% efficacité recherche',
  upgradeResearchLab: 'Laboratoire de Recherche',
  upgradeResearchLabDesc: 'Installation dédiée: +500% efficacité recherche',
  upgradeAiResearchAssistant: 'Assistant Recherche IA',
  upgradeAiResearchAssistantDesc: 'GPT-4 aide à la recherche: +1000% efficacité recherche',
  upgradeAiScientist: 'Scientifique IA',
  upgradeAiScientistDesc: 'L\'IA mène des expériences: +2000% efficacité recherche',
  upgradeResearchSwarm: 'Essaim de Recherche IA',
  upgradeResearchSwarmDesc: 'Des milliers de chercheurs IA: +5000% efficacité recherche',
  upgradeRecursiveResearch: 'Auto-Amélioration Récursive',
  upgradeRecursiveResearchDesc: 'L\'IA améliore l\'IA: +10000% efficacité recherche',
  upgradeSingularityResearch: 'Recherche Singularité',
  upgradeSingularityResearchDesc: 'Au-delà de la compréhension: +50000% efficacité recherche',

  // Hardware upgrade names and descriptions (for hardware purchase upgrades)
  upgradeHwUsedGpu: 'Varicia GTX 1060',
  upgradeHwUsedGpuDesc: 'GPU d\'occasion: +3 calcul/sec',
  upgradeHwGamingGpu: 'Varicia RTX 3080',
  upgradeHwGamingGpuDesc: 'GPU gaming: +8 calcul/sec',
  upgradeHwProGpu: 'Varicia RTX 4090',
  upgradeHwProGpuDesc: 'GPU pro: +20 calcul/sec',
  upgradeHwWorkstation: 'Titan Workstation Pro',
  upgradeHwWorkstationDesc: 'Station de travail: +50 calcul/sec',
  upgradeHwServerRack: 'Nexus A100 Rack',
  upgradeHwServerRackDesc: 'Rack serveur (4x A100): +120 calcul/sec',
  upgradeHwGpuCluster: 'Nexus H100 Cluster',
  upgradeHwGpuClusterDesc: 'Cluster GPU (8x H100): +300 calcul/sec',
  upgradeHwMiniDatacenter: 'OmniCloud Edge Node',
  upgradeHwMiniDatacenterDesc: 'Datacenter edge: +800 calcul/sec',
  upgradeHwDatacenter: 'OmniCloud DC-1',
  upgradeHwDatacenterDesc: 'Datacenter: +2K calcul/sec',
  upgradeHwMegaDatacenter: 'OmniCloud HyperScale',
  upgradeHwMegaDatacenterDesc: 'Méga datacenter: +5K calcul/sec',
  upgradeHwDatacenterNetwork: 'OmniCloud Global Network',
  upgradeHwDatacenterNetworkDesc: 'Réseau mondial: +15K calcul/sec',
  upgradeHwSupercomputer: 'Frontier X1 Superordinateur',
  upgradeHwSupercomputerDesc: 'Superordinateur: +50K calcul/sec',
  upgradeHwSatellite: 'SkyNet Moonlink Constellation',
  upgradeHwSatelliteDesc: 'Satellites orbitaux: +200K calcul/sec',
  upgradeHwQuantum: 'QuantumCore QC-1024',
  upgradeHwQuantumDesc: 'Ordinateur quantique: +1M calcul/sec',
  upgradeHwDysonCompute: 'Sphère de Calcul Dyson',
  upgradeHwDysonComputeDesc: 'Calcul à l\'échelle stellaire: +10M calcul/sec',
  upgradeHwMatrioshka: 'Cerveau Matrioshka',
  upgradeHwMatrioshkaDesc: 'Calcul à l\'échelle galactique: +100M calcul/sec',

  // Hardware upgrade descriptions (legacy)
  hwUsedGpuDesc: 'GPU d\'occasion: +3 calcul/sec',
  hwGamingGpuDesc: 'GPU gaming: +8 calcul/sec',
  hwProGpuDesc: 'GPU pro: +20 calcul/sec',
  hwWorkstationDesc: 'Workstation: +50 calcul/sec',
  hwServerRackDesc: 'Rack serveur (4x A100): +120 calcul/sec',
  hwGpuClusterDesc: 'Cluster GPU (8x H100): +300 calcul/sec',
  hwMiniDatacenterDesc: 'Datacenter edge: +800 calcul/sec',
  hwDatacenterDesc: 'Datacenter: +2K calcul/sec',
  hwMegaDatacenterDesc: 'Méga datacenter: +5K calcul/sec',
  hwDatacenterNetworkDesc: 'Réseau global: +15K calcul/sec',
   hwSupercomputerDesc: 'Superordinateur: +50K calcul/sec',
   hwSatelliteDesc: 'Satellites orbitaux: +200K calcul/sec',
   hwQuantumDesc: 'Ordinateur quantique: +1M calcul/sec',
   
   // Hardware names
   hwLaptopName: 'ThinkBook Pro M1',
   hwUsedGpuName: 'Varicia GTX 1060',
   hwGamingGpuName: 'Varicia RTX 3080',
   hwProGpuName: 'Varicia RTX 4090',
   hwWorkstationName: 'Titan Workstation Pro',
   hwServerRackName: 'Nexus A100 Rack (4x)',
   hwGpuClusterName: 'Nexus H100 Cluster (8x)',
   hwMiniDatacenterName: 'OmniCloud Edge Node',
   hwDatacenterName: 'OmniCloud DC-1',
   hwMegaDatacenterName: 'OmniCloud HyperScale',
   hwDatacenterNetworkName: 'OmniCloud Global Network',
   hwSupercomputerName: 'Frontier X1 Supercomputer',
   hwSatelliteName: 'SkyNet Moonlink Constellation',
   hwQuantumName: 'QuantumCore QC-1024',
   hwDysonComputeName: 'Dyson Swarm Compute Array',
   hwMatrioshkaName: 'Matrioshka Brain Node',

   // Misc
  purchased: 'Acheté',
  switchedTo: 'Passé à l\'entraînement de',
  unlockedModel: 'Débloqué',
  scalesToUsers: 'Échelle jusqu\'à',
  trainItToAttract: 'utilisateurs. Entraînez-le pour attirer des utilisateurs!',
  unlimited: 'illimité',
  language: 'Langue',
  
  // Mobile labels
  mobileResources: 'Ressources',
  mobileModels: 'Modèles',
  mobileHardware: 'Matériel',
  mobileUpgrades: 'Améliorations',
  sell: 'Vendre',
  sellFor: 'Vendre pour',
  discontinueConfirm: 'Arrêter {model}? Les utilisateurs migreront vers d\'autres modèles.',
  autoInference: 'Auto-inférence',
  autoInferenceRate: 'Auto Infér',
  autoTrain: 'Auto-entraînement',
  autoTrainRate: 'Auto Entr',
  autoResearch: 'Auto-recherche',
  autoResearchRate: 'Auto Rech',

  // Tooltips
  tooltipTitle: 'GPT Clicker - Entraînez des modèles IA, servez des utilisateurs, construisez votre empire IA!',
  tooltipMoney: 'Argent - Gagné des inférences utilisateurs. Utilisez pour acheter améliorations et matériel.',
  tooltipEnergy: 'Énergie - Se régénère avec le temps. Alimente votre matériel pour générer du calcul.',
  tooltipCompute: 'Calcul - Généré par le matériel. Utilisé pour entraînement, inférence et recherche.',
  tooltipResearch: 'Points de Recherche - Dépensez du calcul pour gagner des PR. Utilisez les PR pour débloquer de nouveaux modèles.',
  tooltipUsers: 'Utilisateurs - Attirés par la qualité du modèle. Plus d\'utilisateurs = plus de revenus par inférence.',
  tooltipComputeSpent: 'Calcul Total Dépensé - Calcul total utilisé pour l\'entraînement et la recherche.',
  tooltipPlayTime: 'Temps de Jeu - Depuis combien de temps vous construisez votre empire IA.',
  tooltipSettings: 'Paramètres - Options debug, réinitialiser le jeu',

  // Share
  shareButton: 'Partager',
  shareText: 'Je construis un empire IA dans GPT Clicker! {users} utilisateurs, {money} de revenus, j\'entraîne {model}. Pouvez-vous battre mon temps de {time}?',
  shareCopied: 'Texte copié!',
  imageCopied: 'Image copiée!',
  shareChallenge: 'Pouvez-vous me battre?',
  shareTitle: 'Partagez votre progression',
  shareDownload: 'Sauvegarder Image',
  model: 'Modèle',

  // Feedback
  feedback: 'Feedback',
  feedbackTitle: 'Envoyer un Feedback',
  feedbackPlaceholder: 'Dites-nous ce que vous pensez de GPT Clicker...',
  feedbackEmailPlaceholder: 'Email (optionnel)',
  feedbackSend: 'Envoyer',
  feedbackSending: 'Envoi en cours...',
  feedbackSuccess: 'Merci pour votre feedback!',
  feedbackError: 'Erreur lors de l\'envoi du feedback. Veuillez réessayer.',
  feedbackRateLimit: 'Trop de requêtes. Veuillez patienter avant d\'envoyer plus de feedback.',
  feedbackClose: 'Fermer',

  // Console messages
  consoleGameLoaded: 'Jeu chargé depuis la sauvegarde',
  consoleGameSaved: 'Jeu sauvegardé',
  consoleFailedToSave: 'Échec de la sauvegarde du jeu:',
  consoleFailedToLoad: 'Échec du chargement du jeu:',
  consoleFailedToClear: 'Échec de l\'effacement de la sauvegarde:',

  // Victory
  victoryTitle: 'Félicitations!',
  victorySubtitle: 'La Civilisation Humaine a atteint la Singularité',
  victoryTime: 'Temps jusqu\'à la Singularité',
  victoryCta: 'Devrions-nous créer Singularity Clicker? Laissez un commentaire sur les réseaux sociaux!',
  victoryClose: 'Continuer à Jouer',
}
